import { HttpClientModule } from '@angular/common/http';
import { Component, InjectionToken, Inject, Directive, ElementRef, EventEmitter, Output, NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@ngx-translate/core';
class GraphLoadBarComponent {
}
GraphLoadBarComponent.ɵfac = function GraphLoadBarComponent_Factory(t) { return new (t || GraphLoadBarComponent)(); };
GraphLoadBarComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: GraphLoadBarComponent, selectors: [["graph-load-bar"]], decls: 5, vars: 0, consts: [[1, "bar"]], template: function GraphLoadBarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelement(1, "div", 0)(2, "div", 0)(3, "div", 0)(4, "div", 0);
        ɵngcc0.ɵɵelementEnd();
    } }, styles: ["[_nghost-%COMP%]{display:-webkit-box;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;flex-direction:row;-webkit-box-pack:center;justify-content:center;-webkit-box-align:center;align-items:center}.bar[_ngcontent-%COMP%]{background-color:#dddfe0;float:left;margin-right:8px;width:13px;height:40px;-webkit-animation-duration:1s;animation-duration:1s;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite;-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out;-webkit-animation-name:loadingbar;animation-name:loadingbar}.bar[_ngcontent-%COMP%]:last-child{margin-right:0}.bar[_ngcontent-%COMP%]:nth-child(2){-webkit-animation-delay:.2s;animation-delay:.2s}.bar[_ngcontent-%COMP%]:nth-child(3){-webkit-animation-delay:.4s;animation-delay:.4s}.bar[_ngcontent-%COMP%]:nth-child(4){-webkit-animation-delay:.3s;animation-delay:.3s}@-webkit-keyframes loadingbar{0%,100%{margin-top:5px;height:35px}50%{margin-top:35px;height:5px}}@keyframes loadingbar{0%,100%{margin-top:5px;height:35px}50%{margin-top:35px;height:5px}}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(GraphLoadBarComponent, [{
        type: Component,
        args: [{ selector: 'graph-load-bar', template: "<div>\n  <div class=\"bar\"></div>\n  <div class=\"bar\"></div>\n  <div class=\"bar\"></div>\n  <div class=\"bar\"></div>\n</div>\n", styles: [":host{display:-webkit-box;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;flex-direction:row;-webkit-box-pack:center;justify-content:center;-webkit-box-align:center;align-items:center}.bar{background-color:#dddfe0;float:left;margin-right:8px;width:13px;height:40px;-webkit-animation-duration:1s;animation-duration:1s;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite;-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out;-webkit-animation-name:loadingbar;animation-name:loadingbar}.bar:last-child{margin-right:0}.bar:nth-child(2){-webkit-animation-delay:.2s;animation-delay:.2s}.bar:nth-child(3){-webkit-animation-delay:.4s;animation-delay:.4s}.bar:nth-child(4){-webkit-animation-delay:.3s;animation-delay:.3s}@-webkit-keyframes loadingbar{0%,100%{margin-top:5px;height:35px}50%{margin-top:35px;height:5px}}@keyframes loadingbar{0%,100%{margin-top:5px;height:35px}50%{margin-top:35px;height:5px}}"] }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const NAMESPACE_TOKEN = new InjectionToken('NamespaceToken');
class IndeterminateLoadBarComponent {
    /**
     * @param {?=} _namespace
     */
    constructor(_namespace = '') {
        this._namespace = _namespace;
        this.namespace = _namespace;
    }
}
IndeterminateLoadBarComponent.ɵfac = function IndeterminateLoadBarComponent_Factory(t) { return new (t || IndeterminateLoadBarComponent)(ɵngcc0.ɵɵdirectiveInject(NAMESPACE_TOKEN)); };
IndeterminateLoadBarComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: IndeterminateLoadBarComponent, selectors: [["indeterminate-load-bar"]], decls: 6, vars: 3, consts: [[1, "container"], [1, "description"], [1, "rail"], [1, "loadbar"]], template: function IndeterminateLoadBarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵpipe(3, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 2);
        ɵngcc0.ɵɵelement(5, "div", 3);
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(3, 1, ctx.namespace + "IndeterminateLoadingBar.LoadingMessage"), " ");
    } }, dependencies: [ɵngcc1.TranslatePipe], styles: ["[_nghost-%COMP%]{display:-webkit-box;display:flex;-webkit-box-pack:center;justify-content:center}.container[_ngcontent-%COMP%]{width:100%;max-width:520px;padding-left:10px;padding-right:10px}.container[_ngcontent-%COMP%]   .description[_ngcontent-%COMP%]{color:#333;font-size:12px;width:100%;text-align:center;margin-bottom:10px;font-family:ProximaNova;font-weight:400}.container[_ngcontent-%COMP%]   .rail[_ngcontent-%COMP%]{width:100%;height:3px;overflow:hidden;background-color:#ccc}.container[_ngcontent-%COMP%]   .rail[_ngcontent-%COMP%]   .loadbar[_ngcontent-%COMP%]{background-color:#2cb3ca;width:20%;height:100%;animation-duration:1s;animation-name:slidein;animation-iteration-count:infinite;animation-direction:alternate;animation-timing-function:ease-in-out;-webkit-animation-duration:1s;-webkit-animation-name:slidein;-webkit-animation-iteration-count:infinite;-webkit-animation-direction:alternate;-webkit-animation-timing-function:ease-in-out}@keyframes slidein{from{margin-left:90%}to{margin-left:-10%}}@-webkit-keyframes slidein{from{margin-left:90%}to{margin-left:-10%}}"] });
/** @nocollapse */
IndeterminateLoadBarComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [NAMESPACE_TOKEN,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(IndeterminateLoadBarComponent, [{
        type: Component,
        args: [{ selector: 'indeterminate-load-bar', template: "<div class=\"container\">\n  <div class=\"description\">\n    {{namespace +  'IndeterminateLoadingBar.LoadingMessage' | translate}}\n  </div>\n  <div class=\"rail\">\n    <div class=\"loadbar\"></div>\n  </div>\n</div>\n", styles: [":host{display:-webkit-box;display:flex;-webkit-box-pack:center;justify-content:center}.container{width:100%;max-width:520px;padding-left:10px;padding-right:10px}.container .description{color:#333;font-size:12px;width:100%;text-align:center;margin-bottom:10px;font-family:ProximaNova;font-weight:400}.container .rail{width:100%;height:3px;overflow:hidden;background-color:#ccc}.container .rail .loadbar{background-color:#2cb3ca;width:20%;height:100%;animation-duration:1s;animation-name:slidein;animation-iteration-count:infinite;animation-direction:alternate;animation-timing-function:ease-in-out;-webkit-animation-duration:1s;-webkit-animation-name:slidein;-webkit-animation-iteration-count:infinite;-webkit-animation-direction:alternate;-webkit-animation-timing-function:ease-in-out}@keyframes slidein{from{margin-left:90%}to{margin-left:-10%}}@-webkit-keyframes slidein{from{margin-left:90%}to{margin-left:-10%}}"] }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [NAMESPACE_TOKEN]
            }] }]; }, null); })();
if (false) {
    /** @type {?} */
    IndeterminateLoadBarComponent.prototype.namespace;
    /**
     * @type {?}
     * @private
     */
    IndeterminateLoadBarComponent.prototype._namespace;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class EllipsisTooltipDirective {
    /**
     * @param {?} elRef
     */
    constructor(elRef) {
        this.elRef = elRef;
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        if (this.isEllipsis()) {
            this.setupTooltip();
        }
    }
    /**
     * @private
     * @return {?}
     */
    isEllipsis() {
        const { nativeElement: { offsetWidth, scrollWidth } } = this.elRef;
        return offsetWidth < scrollWidth;
    }
    /**
     * @private
     * @return {?}
     */
    setupTooltip() {
        const { nativeElement } = this.elRef;
        const { textContent } = nativeElement;
        if (textContent !== null) {
            nativeElement.setAttribute('title', textContent);
        }
    }
}
EllipsisTooltipDirective.ɵfac = function EllipsisTooltipDirective_Factory(t) { return new (t || EllipsisTooltipDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
EllipsisTooltipDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: EllipsisTooltipDirective, selectors: [["", "ellipsisTooltip", ""]] });
/** @nocollapse */
EllipsisTooltipDirective.ctorParameters = () => [
    { type: ElementRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EllipsisTooltipDirective, [{
        type: Directive,
        args: [{ selector: '[ellipsisTooltip]' }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    EllipsisTooltipDirective.prototype.elRef;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function HoverEvent() { }
if (false) {
    /** @type {?} */
    HoverEvent.prototype.el;
    /** @type {?} */
    HoverEvent.prototype.hovering;
}
class OnHoverDirective {
    /**
     * @param {?} elRef
     */
    constructor(elRef) {
        this.elRef = elRef;
        this.onHover = new EventEmitter();
        this.onMouseOver = this.onMouseOver.bind(this);
        this.onMouseOut = this.onMouseOut.bind(this);
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        this.elRef.nativeElement.addEventListener('mouseover', this.onMouseOver);
        this.elRef.nativeElement.addEventListener('mouseout', this.onMouseOut);
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.elRef.nativeElement.removeEventListener('mouseover', this.onMouseOver);
        this.elRef.nativeElement.removeEventListener('mouseout', this.onMouseOut);
    }
    /**
     * @private
     * @return {?}
     */
    onMouseOver() {
        this._onHover(true);
    }
    /**
     * @private
     * @return {?}
     */
    onMouseOut() {
        this._onHover(false);
    }
    /**
     * @private
     * @param {?} hovering
     * @return {?}
     */
    _onHover(hovering) {
        this.onHover.emit({ el: this.elRef.nativeElement, hovering });
    }
}
OnHoverDirective.ɵfac = function OnHoverDirective_Factory(t) { return new (t || OnHoverDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
OnHoverDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: OnHoverDirective, selectors: [["", "onHover", ""]], outputs: { onHover: "onHover" } });
/** @nocollapse */
OnHoverDirective.ctorParameters = () => [
    { type: ElementRef }
];
OnHoverDirective.propDecorators = {
    onHover: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OnHoverDirective, [{
        type: Directive,
        args: [{ selector: '[onHover]' }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { onHover: [{
            type: Output
        }] }); })();
if (false) {
    /** @type {?} */
    OnHoverDirective.prototype.onHover;
    /**
     * @type {?}
     * @private
     */
    OnHoverDirective.prototype.elRef;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function NgxUxComponentsModuleConfig() { }
if (false) {
    /** @type {?} */
    NgxUxComponentsModuleConfig.prototype.namespace;
}
class NgxUxComponentsModule {
    /**
     * @param {?} config
     * @return {?}
     */
    static forRoot(config) {
        return {
            ngModule: NgxUxComponentsModule,
            providers: [
                { provide: NAMESPACE_TOKEN, useValue: config.namespace },
            ],
        };
    }
}
NgxUxComponentsModule.ɵfac = function NgxUxComponentsModule_Factory(t) { return new (t || NgxUxComponentsModule)(); };
NgxUxComponentsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NgxUxComponentsModule });
NgxUxComponentsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [TranslateModule,
        HttpClientModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxUxComponentsModule, [{
        type: NgModule,
        args: [{
                imports: [
                    TranslateModule,
                    HttpClientModule,
                ],
                declarations: [GraphLoadBarComponent, IndeterminateLoadBarComponent, EllipsisTooltipDirective, OnHoverDirective],
                exports: [GraphLoadBarComponent, IndeterminateLoadBarComponent, EllipsisTooltipDirective, OnHoverDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxUxComponentsModule, { declarations: function () { return [GraphLoadBarComponent, IndeterminateLoadBarComponent, EllipsisTooltipDirective, OnHoverDirective]; }, imports: function () { return [TranslateModule,
        HttpClientModule]; }, exports: function () { return [GraphLoadBarComponent, IndeterminateLoadBarComponent, EllipsisTooltipDirective, OnHoverDirective]; } }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { NgxUxComponentsModule, OnHoverDirective as ɵa, GraphLoadBarComponent as ɵb, NAMESPACE_TOKEN as ɵc, IndeterminateLoadBarComponent as ɵd, EllipsisTooltipDirective as ɵe };

